export const AUS_TIMEZONES = [
  {
    label: 'Sydney / Melbourne / Hobart',
    value: 'Australia/Sydney',
  },
  {
    label: 'Brisbane',
    value: 'Australia/Brisbane',
  },
  {
    label: 'Adelaide',
    value: 'Australia/Adelaide',
  },
  {
    label: 'Perth',
    value: 'Australia/Perth',
  },
  {
    label: 'Darwin',
    value: 'Australia/Darwin',
  },
];
